

import bharat from "../Images/Screenshot (259).png"
import bharat1 from "../Images/DSC_0388_copyq-removebg-preview (1).png"
import { Box, Image } from "@chakra-ui/react"
import { useContext } from "react"
import { ColorContext } from "../Context/ColorContext"

function Photo(){
    let val = useContext(ColorContext)

    console.log(val)

    return (
       <Box borderRadius={'50%'}>
         <Box className="Images"  mt={'20%'}  >
         <Image display={['block','block','block','inline']} m={['auto','auto','auto','none']} src={bharat1} className="home-img" alt="" bgColor={val.colors} w={['70%','80%','90%%','100%']}  borderRadius={'50%'} />
         {/* class="home-img" */}
        </Box>
       </Box>
    )

}

export default Photo
